import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import { Button } from "../Button";
import OutsideClickListener from "../internal/OutsideClickListener";
import { CSSTransitionPortal } from "../Portal";
const SnackbarRoot = styled(Flex)`
  position: fixed;
  top: 16px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 200;

  ${media.up("medium", "pointer")} {
    top: 56px;
  }
`;
const SnackbarWrapper = styled(Flex)`
  opacity: 0;
  transform: scale(0.98);

  transition: transform 0.15s cubic-bezier(0.4, 0, 1, 1),
    opacity 0.15s cubic-bezier(0.4, 0, 1, 1);

  [class*="enter-"] & {
    opacity: 1;
    transform: scale(1);
    transition: transform 0.2s cubic-bezier(0, 0, 0.2, 1),
      opacity 0.2s cubic-bezier(0, 0, 0.2, 1);
  }

  max-width: calc(100% - 32px);

  button {
    pointer-events: auto;
  }
`;
const animationTimeout = {
    enter: 200,
    exit: 150
};
const timeout = 2750;
const Snackbar = (props)=>{
    const { message , open , onRequestClose , onExited , actionText , onActionClick  } = props;
    const timer = useRef(null);
    const stopTimer = useCallback(()=>{
        if (timer.current !== null) clearTimeout(timer.current);
    }, []);
    const startTimer = useCallback((duration)=>{
        stopTimer();
        timer.current = setTimeout(()=>{
            onRequestClose();
        }, duration || timeout);
    }, [
        onRequestClose,
        stopTimer
    ]);
    const handleMouseLeave = useCallback(()=>{
        startTimer(timeout * 0.5);
    }, [
        startTimer
    ]);
    const handleClick = useCallback(()=>{
        if (onActionClick) onActionClick();
        onRequestClose();
    }, [
        onActionClick,
        onRequestClose
    ]);
    useEffect(()=>{
        if (open) startTimer();
        else stopTimer();
    }, [
        open,
        startTimer,
        stopTimer
    ]);
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
        open: open,
        timeout: animationTimeout,
        onExited: onExited,
        children: /*#__PURE__*/ _jsx(SnackbarRoot, {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ _jsx(OutsideClickListener, {
                onOutsideClick: onRequestClose,
                children: /*#__PURE__*/ _jsxs(SnackbarWrapper, {
                    alignItems: "center",
                    color: "white.100",
                    bg: "#323232",
                    borderRadius: "30px",
                    px: "16px",
                    onMouseEnter: stopTimer,
                    onMouseLeave: handleMouseLeave,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            lineHeight: "20px",
                            as: "span",
                            py: "10px",
                            children: message
                        }),
                        actionText && /*#__PURE__*/ _jsx(Box, {
                            ml: "auto",
                            pl: "8px",
                            mr: "-12px",
                            flex: "none",
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "bright-blue",
                                size: "sm",
                                onClick: handleClick,
                                children: actionText
                            })
                        })
                    ]
                })
            })
        })
    });
};
export default Snackbar;
